import MuiTabs, { TabsProps } from '@mui/material/Tabs';

function Tabs(props: TabsProps) {
  return <MuiTabs {...props} />;
}

export default Tabs;
